const input = document.querySelector("#phone");
const iti = intlTelInput(input, {
 initialCountry: "auto",
 separateDialCode: true,
 geoIpLookup: function (callback) {
  callback('pl');
 },
 utilsScript: "../build/js/utils.js"
});